import moment, { Moment } from 'moment'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'

const estWeekEnd = (date: Moment) => date.day() === 0 || date.day() === 6

const estJourFerie = (date: Moment, joursFeries: string[]) => joursFeries.some((jourFerie) => date.isSame(jourFerie, 'day'))

// Grise les samedis, dimanches et jours fériés d'un calendrier.
export const shouldBlockCalendarDay = (date: MaterialUiPickersDate, joursFeries: string[]) => !!date && (estWeekEnd(date) || estJourFerie(date, joursFeries))

// Renvoie la première date non bloquée à partir de la date fournie, au format YYYY-MM-DD.
export const getNextAvailableDay = (dateDepart: string, joursFeries: string[]) => {
	const date = moment(dateDepart, 'YYYY-MM-DD')

	while (estWeekEnd(date) || estJourFerie(date, joursFeries)) {
		date.add(1, 'day')
	}

	return date.format('YYYY-MM-DD')
}
